/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ClientCallResult } from '../model/clientCallResult';
import { SseEmitter } from '../model/sseEmitter';
import { TurnRequest } from '../model/turnRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ChatTurnControllerService {

    protected basePath = 'https://api.beta.planbic.de';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param turnId 
     * @param callId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public answerClientCall(body: ClientCallResult, turnId: string, callId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public answerClientCall(body: ClientCallResult, turnId: string, callId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public answerClientCall(body: ClientCallResult, turnId: string, callId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public answerClientCall(body: ClientCallResult, turnId: string, callId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling answerClientCall.');
        }

        if (turnId === null || turnId === undefined) {
            throw new Error('Required parameter turnId was null or undefined when calling answerClientCall.');
        }

        if (callId === null || callId === undefined) {
            throw new Error('Required parameter callId was null or undefined when calling answerClientCall.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/chat/turns/${encodeURIComponent(String(turnId))}/client-calls/${encodeURIComponent(String(callId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param threadId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public ask(body: TurnRequest, threadId: string, observe?: 'body', reportProgress?: boolean): Observable<SseEmitter>;
    public ask(body: TurnRequest, threadId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SseEmitter>>;
    public ask(body: TurnRequest, threadId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SseEmitter>>;
    public ask(body: TurnRequest, threadId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling ask.');
        }

        if (threadId === null || threadId === undefined) {
            throw new Error('Required parameter threadId was null or undefined when calling ask.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/event-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SseEmitter>('post',`${this.basePath}/chat/threads/${encodeURIComponent(String(threadId))}/turns`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param turnId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cancel(turnId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public cancel(turnId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public cancel(turnId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public cancel(turnId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (turnId === null || turnId === undefined) {
            throw new Error('Required parameter turnId was null or undefined when calling cancel.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('post',`${this.basePath}/chat/turns/${encodeURIComponent(String(turnId))}/cancel`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param turnId 
     * @param fromSeq 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public follow(turnId: string, fromSeq?: number, observe?: 'body', reportProgress?: boolean): Observable<SseEmitter>;
    public follow(turnId: string, fromSeq?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SseEmitter>>;
    public follow(turnId: string, fromSeq?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SseEmitter>>;
    public follow(turnId: string, fromSeq?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (turnId === null || turnId === undefined) {
            throw new Error('Required parameter turnId was null or undefined when calling follow.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (fromSeq !== undefined && fromSeq !== null) {
            queryParameters = queryParameters.set('fromSeq', <any>fromSeq);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/event-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SseEmitter>('get',`${this.basePath}/chat/turns/${encodeURIComponent(String(turnId))}/follow`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param threadId 
     * @param messageId 
     * @param mode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public regenerate(threadId: string, messageId: string, mode?: string, observe?: 'body', reportProgress?: boolean): Observable<SseEmitter>;
    public regenerate(threadId: string, messageId: string, mode?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SseEmitter>>;
    public regenerate(threadId: string, messageId: string, mode?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SseEmitter>>;
    public regenerate(threadId: string, messageId: string, mode?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (threadId === null || threadId === undefined) {
            throw new Error('Required parameter threadId was null or undefined when calling regenerate.');
        }

        if (messageId === null || messageId === undefined) {
            throw new Error('Required parameter messageId was null or undefined when calling regenerate.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (mode !== undefined && mode !== null) {
            queryParameters = queryParameters.set('mode', <any>mode);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/event-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SseEmitter>('post',`${this.basePath}/chat/threads/${encodeURIComponent(String(threadId))}/messages/${encodeURIComponent(String(messageId))}/regenerate`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param turnId 
     * @param fromSeq 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public replay(turnId: string, fromSeq?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<any>>;
    public replay(turnId: string, fromSeq?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<any>>>;
    public replay(turnId: string, fromSeq?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<any>>>;
    public replay(turnId: string, fromSeq?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (turnId === null || turnId === undefined) {
            throw new Error('Required parameter turnId was null or undefined when calling replay.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (fromSeq !== undefined && fromSeq !== null) {
            queryParameters = queryParameters.set('fromSeq', <any>fromSeq);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<any>>('get',`${this.basePath}/chat/turns/${encodeURIComponent(String(turnId))}/stream`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
